import React from 'react'
import { Header, Header2, Header3 } from '@app/components/general/header'
import { Link } from '../typo/link'

type AuthorProps = {
  author?: string
  intro?: string
  small?: boolean
  head2?: boolean
  nohead?: boolean
}

export const Author = ({
  author,
  intro,
  small,
  head2,
  nohead,
}: AuthorProps) => {
  if (small) {
    return (
      <div className='gap-2 flex flex-col place-items-center place-content-center'>
        <Link
          href={'/blog/authors/jeff-mendez'}
          className={'hover:opacity-80'}
          rel={'author'}
        >
          <img
            alt={author}
            src='/img/webflow/jmendez-hs.webp'
            srcSet='/img/webflow/jmendez-hs-500.png 500w, /img/webflow/jmendez-hs-800.webp 800w, /img/webflow/jmendez-hs-1080.webp 1080w, /img/webflow/j-mendez-full.webp 1350w'
            sizes='(max-width: 479px) 130px, (max-width: 767px) 210px, 300px'
            width={80}
            height={80}
            className='rounded-full'
          />
        </Link>
        <div className='pb-1'>
          {nohead ? (
            <div className='text-center xl:text-lg'>{author}</div>
          ) : head2 ? (
            <Header2 className='text-center xl:text-lg'>{author}</Header2>
          ) : (
            <Header3 className='text-center xl:text-lg'>{author}</Header3>
          )}
          <p className='text-gray-800 dark:text-gray-100'>{intro}</p>
        </div>
      </div>
    )
  }

  return (
    <div className='gap-3 flex flex-wrap w-full'>
      <div className='w-full'>
        <img
          alt={author}
          src='/img/webflow/jmendez-hs.webp'
          srcSet='/img/webflow/jmendez-hs-500.png 500w, /img/webflow/jmendez-hs-800.webp 800w, /img/webflow/jmendez-hs-1080.webp 1080w, /img/webflow/j-mendez-full.webp 1350w'
          sizes='(max-width: 479px) 130px, (max-width: 767px) 210px, 300px'
          className='author-picture'
        />
        <div className='space-y-2'>
          <Header className='text-center md:text-left'>{author}</Header>
          <p className='text-gray-800 dark:text-gray-100'>{intro}</p>
        </div>
      </div>
    </div>
  )
}
